import { SeoHelpers } from 'helpers'
import { GetItFixedButton } from 'components'

import './verdictBlock.scss'

export default class VerdictBlock extends React.Component {
  static propTypes = {
    checkType: React.PropTypes.object.isRequired,
    result: React.PropTypes.object.isRequired,
  }

  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object.isRequired,
  }

  render() {
    const { result, checkType } = this.props
    const palette = this.context.muiTheme.palette

    let severityColor = { background: '#999999', foreground: '#000000' }
    if (result.get('executeResult') == 'Success')
      severityColor = SeoHelpers.severityColor(
        result.get('verdict'),
        this.context.muiTheme,
      )

    let verdict = null
    if (result.get('verdictFriendly')) {
      verdict = (
        <div className="flex-center--horizontal">
          <h5
            className="verdictBlock__friendly"
            style={{
              color: severityColor.foreground,
              backgroundColor: severityColor.background,
            }}
          >
            {result.get('verdictFriendly')} - {result.get('subtext')}
          </h5>
          <GetItFixedButton
            checkType={checkType}
            result={result}
            pageLocation="top"
          />
        </div>
      )
    }

    return (
      <div
        className="verdictBlock"
        style={{
          color: palette.alternateTextColor,
          backgroundColor: palette.accent2Color,
        }}
      >
        {verdict}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/VerdictBlock.js